import { sendVerificationEmail, sendVerificationMessage } from 'apis/oauth'
import GeetestCheck from 'com/GeetestCheck'
import store from './simpleStore'
export default {
  data() {
    return {
      state: store.state
    }
  },
  computed: {
    body() {
      return this.state.body
    },
    curStep() {
      return this.state.curStep
    },
    countDown() {
      return this.state.countDown
    },
    error() {
      return this.state.error
    },
    mode: {
      set: function(val) {
        store.setModeAction(val)
      },
      get: function() {
        return this.state.mode
      }
    },
    params() {
      const tel = this.body.tel || { code: '', phone: '' }
      const params = {
        grant_type: this.mode,
        login_password: this.body.password_2,
        verify_code: this.body.code
      }
      if (this.mode === 'phone') {
        params.tel_code = tel.code
        params.username = tel.phone
      }
      if (this.mode === 'email') {
        params.username = this.body.email
      }
      if (this.body.invite_code) {
        params.invite_code = this.body.invite_code
      }
      return params
    }
  },
  components: {
    GeetestCheck
  },
  methods: {
    initGeetest() {
      this.loading = true
      this.clearError()
      this.$refs.geetest.init()
    },
    geetestPass(data) {
      if (this.signupSuccess) {
        // 注册成功登录需要极验，通过后直接登录
        const params = {
          grant_type: this.params.grant_type,
          login_password: this.params.login_password,
          username: this.params.username,
          tel_code: this.params.tel_code,
          ...data
        }
        this.$store.dispatch('userLogin', params)
      } else {
        this.sendCode(data)
      }
    },
    async sendCode(geetest) {
      // 默认设置邮箱方式
      let sendRequest = sendVerificationEmail
      if (this.mode !== 'email') {
        sendRequest = sendVerificationMessage
      }
      this.clearError()
      const params = { ...this.generateParam(), ...geetest }
      try {
        this.loading = true
        const { data: respData } = await sendRequest(params)
        if (respData.is_succ) {
          this._sendSuccess()
        } else {
          throw respData.data
        }
        this.loading = false
      } catch (error) {
        this._errorHandler(error)
        this.loading = false
      }
    },
    _sendSuccess() {
      this.$track('login_signup_captcha')
      this.setCountDown(60)
      this.$emit('start-count-down')
      this.setStep('2')
      this.clearError()
      // 验证码重发清空输入框
      if (this.code) {
        this.code = ''
      }
    },
    _errorHandler(error) {
      const errorInfo = error.error_description || error.error_message
      store.setErrorAction(errorInfo)
    },
    clearError() {
      store.setErrorAction('')
    },
    setStep(step) {
      store.setCurStepAction(step)
    },
    setCountDown(num) {
      store.setCountDownAction(num)
    },
    resetForm() {
      store.resetForm()
    },
    generateParam() {
      if (this.mode === 'email') {
        return {
          email: this.body.email,
          process: 'signup'
        }
      }
      return {
        tel_code: this.body.tel.code,
        phone: this.body.tel.phone,
        process: 'signup',
        voice: 0
      }
    }
  }
}
